<span [style.height.px]="size" [style.--control-width.px]="currentWidth()" class="loader"></span>
